import { lazy, Suspense } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";

const PptEditorDemoPage = lazy(
  () => import("@client/components/ppt-editor-demo/ppt-editor-demo-page"),
);

export const Route = createFileRoute("/ppt-editor-demo")({
  component: PptEditorDemoRoute,
});

function PptEditorDemoRoute() {
  return (
    <Suspense
      fallback={
        <div className="flex h-screen items-center justify-center gap-2 bg-background text-muted-foreground">
          <Loader2 className="size-5 animate-spin" aria-hidden="true" />
          <span>正在加载 PPT 编辑器…</span>
        </div>
      }
    >
      <PptEditorDemoPage />
    </Suspense>
  );
}
